export default "__VITE_ASSET__a9666135__"